// accordion.ts
export class Accordion {
    accordionButtons;
    constructor() {
        this.accordionButtons = document.querySelectorAll("#accordion-collapse button[data-te-collapse-init]");
        this.closeAllAccordionItems(); // Schließen Sie alle Akkordeon-Elemente beim Start
        this.initializeAccordion();
    }
    initializeAccordion() {
        this.accordionButtons.forEach(button => {
            button.setAttribute('data-te-collapse-collapsed', '');
            button.setAttribute('aria-expanded', 'false');
            button.addEventListener('click', () => this.handleButtonClick(button));
        });
    }
    handleButtonClick(button) {
        const targetId = button.getAttribute('data-te-target');
        if (!targetId)
            return;
        const targetElement = document.querySelector(targetId);
        if (targetElement) {
            this.closeAllAccordionItemsExcept(targetId);
            targetElement.classList.toggle('hidden');
            const isExpanded = !targetElement.classList.contains('hidden');
            button.setAttribute('aria-expanded', isExpanded.toString());
            if (isExpanded) {
                button.removeAttribute('data-te-collapse-collapsed');
            }
            else {
                button.setAttribute('data-te-collapse-collapsed', '');
            }
        }
    }
    closeAllAccordionItemsExcept(exceptId) {
        const allItems = document.querySelectorAll("#accordion-collapse [data-te-collapse-item]");
        allItems.forEach(item => {
            if (item.id !== exceptId) {
                item.classList.add('hidden');
            }
            else {
                item.classList.remove('hidden');
            }
            // Setzen des data-te-collapse-collapsed Attributs für den zugehörigen Button
            const button = document.querySelector(`button[data-te-target="#${item.id}"]`);
            if (button) {
                button.setAttribute('data-te-collapse-collapsed', '');
                button.setAttribute('aria-expanded', 'false');
            }
        });
    }
    closeAllAccordionItems() {
        const allItems = document.querySelectorAll("#accordion-collapse [data-te-collapse-item]");
        allItems.forEach(item => {
            item.classList.add('hidden');
        });
        const allButtons = document.querySelectorAll("#accordion-collapse button[data-te-collapse-init]");
        allButtons.forEach(button => {
            button.setAttribute('data-te-collapse-collapsed', '');
            button.setAttribute('aria-expanded', 'false');
        });
    }
}
